export enum LangEnum {
  EN = 'en',
  RU = 'ru',
}
export enum ContainsLogicEnum {
  AND = 'and',
  OR = 'or',
  ONLY = 'only',
}

export type Word = {
  word: string;
  definition?: string;
};
export type Lang = (typeof LangEnum)[keyof typeof LangEnum];
export type IsWithDefinition = boolean;
export type IsCombineDefinition = boolean;
export type Search = string;
export type IsRegex = boolean;
export type MinLength = string;
export type MaxLength = string;
export type Contains = string;
export type ContainsLogic =
  (typeof ContainsLogicEnum)[keyof typeof ContainsLogicEnum];
export type Page = number;
export type Words = Word[];
export type Total = number;
export type Pages = Array<number | null>;
export type WordsRange = string;
export type IsLoading = boolean;

export type AppState = {
  lang: Lang;
  isWithDefinition: IsWithDefinition;
  isCombineDefinition: IsCombineDefinition;
  search: Search;
  isRegex: IsRegex;
  minLength: MinLength;
  maxLength: MaxLength;
  contains: Contains;
  containsLogic: ContainsLogic;
  words: Words;
  total: Total;
  page: Page;
  pages: Pages;
  range: WordsRange;
  isLoading: IsLoading;
  isSettingsOpened: boolean;
  isResetPage: boolean;
};

export type OnChangeComponentParams<Props> = {
  [Properties in keyof Omit<Props, 'onChange'>]?: Props[Properties];
};

export type GetWordsParams = {
  lang: Lang;
  isWithDefinition?: IsWithDefinition;
  isCombineDefinition?: IsCombineDefinition;
  search?: Search;
  isRegex?: IsRegex;
  minLength?: MinLength;
  maxLength?: MaxLength;
  contains?: Contains;
  containsLogic?: ContainsLogic;
  page?: Page;
};

export type GetWordsResponse = {
  page: Page;
  pages: Pages;
  range: WordsRange;
  total: Total;
  words: Word[];
};

export type GetWordsResponseError = {
  message: string;
};
